import Swiper, { Pagination } from "swiper";

function initBlock() {

    if(!$('.block-customers-review').length) { return false }

    if($(window).width() < 992) {
        $(window).on('load', function (e) {
            let swiper = new Swiper('.block-customers-review .swiper', {
                modules: [Pagination],
                slidesPerView: 1,
                spaceBetween: 12,
                pagination: {
                    el: ".block-customers-review .swiper-pagination",
                },
            })
        })
    }

}

initBlock()
